// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7fe4862f","453":"60ef9854","455":"b83d40c3"}[chunkId] + ".chunk.js";
};